<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row d-flex justify-content-center">
              <div class="col-lg-6">
                <div class="px-3 px-lg-0 py-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Recuperação de senha</h1>
                  </div>

                  <form class="user" @submit.prevent="submit">
                    <div class="form-group">
                      <input
                        type="email"
                        required
                        class="form-control form-control-user"
                        aria-describedby="emailHelp"
                        placeholder="Digite o seu e-mail para recuperar sua senha"
                      />
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-user btn-block"
                    >
                      <span class="pr-2">
                        Enviar email de recuperação
                      </span>
                      <div
                        v-if="recovery.status === 'loading'"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </form>
                  <br />
                  <div>
                    <div
                      v-if="recovery.status === 'success'"
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                    >
                      <strong>Quase lá!</strong> Em breve você receberá um email
                      com as instruções para recuperar sua senha.
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <br />

                  <div class="text-center">
                    <router-link :to="{ name: 'Login' }">
                      Voltar ao login
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recoveryPassword } from "@/services/auth";

export default {
  data() {
    return {
      recovery: {
        status: ""
      }
    };
  },

  methods: {
    async submit() {
      this.recovery.status = "loading";
      try {
        await recoveryPassword();
        this.recovery.status = "success";
      } catch (err) {
        this.recovery.status = "error";
      }
    }
  }
};
</script>
